export const HSRAnaxaDPS = {
  V1: {
    // 1 target
    e0: 506199,
    e1: 562854,
    e2: 675424,
    e3: 687128,
    e4: 843416,
    e5: 917868,
    e6: 1385368,
    sig_e0: 581953,
    sig_e1: 653054,
    sig_e2: 783665,
    sig_e3: 798360,
    sig_e4: 994995,
    sig_e5: 1081048,
    sig_e6: 1623086,
    // 3 targets
    alt_e0: 666477,
    alt_e1: 741070,
    alt_e2: 889284,
    alt_e3: 915348,
    alt_e4: 1123544,
    alt_e5: 1208054,
    alt_e6: 1809219,
    alt_sig_e0: 780504,
    alt_sig_e1: 875865,
    alt_sig_e2: 1051038,
    alt_sig_e3: 1084778,
    alt_sig_e4: 1351957,
    alt_sig_e5: 1449446,
    alt_sig_e6: 2162100,
    // 5 targets
    e0_5targets: 826755,
    e1_5targets: 919287,
    e2_5targets: 1103144,
    e3_5targets: 1143567,
    e4_5targets: 1403673,
    e5_5targets: 1498241,
    e6_5targets: 2233069,
    sig_e0_5targets: 979056,
    sig_e1_5targets: 1098675,
    sig_e2_5targets: 1318410,
    sig_e3_5targets: 1371195,
    sig_e4_5targets: 1708919,
    sig_e5_5targets: 1817843,
    sig_e6_5targets: 2701114
  },
  V2: {
    // 1 target
    e0: 803956,
    e1: 893936,
    e2: 1072723,
    e3: 1081934,
    e4: 1328022,
    e5: 1459470,
    e6: 2257497,
    sig_e0: 927504,
    sig_e1: 1040824,
    sig_e2: 1248989,
    sig_e3: 1261324,
    sig_e4: 1571986,
    sig_e5: 1724795,
    sig_e6: 2649131,
    // 3 targets
    alt_e0: 1052527,
    alt_e1: 1170328,
    alt_e2: 1404394,
    alt_e3: 1432028,
    alt_e4: 1757744,
    alt_e5: 1909548,
    alt_e6: 2915956,
    alt_sig_e0: 1230567,
    alt_sig_e1: 1380915,
    alt_sig_e2: 1657098,
    alt_sig_e3: 1694101,
    alt_sig_e4: 2111356,
    alt_sig_e5: 2287193,
    alt_sig_e6: 3474837,
    // 5 targets
    e0_5targets: 1301099,
    e1_5targets: 1446721,
    e2_5targets: 1736065,
    e3_5targets: 1782121,
    e4_5targets: 2187467,
    e5_5targets: 2359626,
    e6_5targets: 3574415,
    sig_e0_5targets: 1533629,
    sig_e1_5targets: 1721005,
    sig_e2_5targets: 2065206,
    sig_e3_5targets: 2126879,
    sig_e4_5targets: 2650726,
    sig_e5_5targets: 2849591,
    sig_e6_5targets: 4300544
  }
};
